import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from 'techlify-ng';

const routes: Routes = [
];
import { OccupationViewAllComponent } from "./occupation-view-all.component";
routes.push({ path: 'occupations', component: OccupationViewAllComponent, canActivate: [AuthGuard] });

export const OccupationRoutingProvider = RouterModule.forRoot(routes, { useHash: true });